var _defineProperty = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _toConsumableArray = require("E:\\project\\lesterlyu.github.io\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var _TextFunctions;

var FormulaError = require('../error');

var _require = require('../helpers'),
    FormulaHelpers = _require.FormulaHelpers,
    Types = _require.Types,
    WildCard = _require.WildCard;

var H = FormulaHelpers; // Spreadsheet number format

var ssf = require('../../ssf/ssf'); // Change number to Thai pronunciation string


var bahttext = require('bahttext'); // full-width and half-width converter


var charsets = {
  latin: {
    halfRE: /[!-~]/g,
    fullRE: /[！-～]/g,
    delta: 0xFEE0
  },
  hangul1: {
    halfRE: /[ﾡ-ﾾ]/g,
    fullRE: /[ᆨ-ᇂ]/g,
    delta: -0xEDF9
  },
  hangul2: {
    halfRE: /[ￂ-ￜ]/g,
    fullRE: /[ᅡ-ᅵ]/g,
    delta: -0xEE61
  },
  kana: {
    delta: 0,
    half: "｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ",
    full: "。「」、・ヲァィゥェォャュョッーアイウエオカキクケコサシ" + "スセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワン゛゜"
  },
  extras: {
    delta: 0,
    half: "\xA2\xA3\xAC\xAF\xA6\xA5\u20A9 |\u2190\u2191\u2192\u2193\u25A0\xB0",
    full: "\uFFE0\uFFE1\uFFE2\uFFE3\uFFE4\uFFE5\uFFE6\u3000\uFFE8\uFFE9\uFFEA\uFFEB\uFFEC\uFFED\uFFEE"
  }
};

var toFull = function toFull(set) {
  return function (c) {
    return set.delta ? String.fromCharCode(c.charCodeAt(0) + set.delta) : _toConsumableArray(set.full)[_toConsumableArray(set.half).indexOf(c)];
  };
};

var toHalf = function toHalf(set) {
  return function (c) {
    return set.delta ? String.fromCharCode(c.charCodeAt(0) - set.delta) : _toConsumableArray(set.half)[_toConsumableArray(set.full).indexOf(c)];
  };
};

var re = function re(set, way) {
  return set[way + "RE"] || new RegExp("[" + set[way] + "]", "g");
};

var sets = Object.keys(charsets).map(function (i) {
  return charsets[i];
});

var toFullWidth = function toFullWidth(str0) {
  return sets.reduce(function (str, set) {
    return str.replace(re(set, "half"), toFull(set));
  }, str0);
};

var toHalfWidth = function toHalfWidth(str0) {
  return sets.reduce(function (str, set) {
    return str.replace(re(set, "full"), toHalf(set));
  }, str0);
};

var TextFunctions = (_TextFunctions = {
  ASC: function ASC(text) {
    text = H.accept(text, Types.STRING);
    return toHalfWidth(text);
  },
  BAHTTEXT: function BAHTTEXT(number) {
    number = H.accept(number, Types.NUMBER);

    try {
      return bahttext(number);
    } catch (e) {
      throw Error("Error in https://github.com/jojoee/bahttext \n".concat(e.toString()));
    }
  },
  CHAR: function CHAR(number) {
    number = H.accept(number, Types.NUMBER);
    if (number > 255 || number < 1) throw FormulaError.VALUE;
    return String.fromCharCode(number);
  },
  CLEAN: function CLEAN(text) {
    text = H.accept(text, Types.STRING);
    return text.replace(/[\x00-\x1F]/g, '');
  },
  CODE: function CODE(text) {
    text = H.accept(text, Types.STRING);
    if (text.length === 0) throw FormulaError.VALUE;
    return text.charCodeAt(0);
  },
  CONCAT: function CONCAT() {
    var text = ''; // does not allow union

    for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    H.flattenParams(params, Types.STRING, false, function (item) {
      item = H.accept(item, Types.STRING);
      text += item;
    });
    return text;
  },
  CONCATENATE: function CONCATENATE() {
    var text = '';

    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }

    if (params.length === 0) throw Error('CONCATENATE need at least one argument.');
    params.forEach(function (param) {
      // does not allow range reference, array, union
      param = H.accept(param, Types.STRING);
      text += param;
    });
    return text;
  },
  DBCS: function DBCS(text) {
    text = H.accept(text, Types.STRING);
    return toFullWidth(text);
  },
  DOLLAR: function DOLLAR(number, decimals) {
    number = H.accept(number, Types.NUMBER);
    decimals = H.accept(decimals, Types.NUMBER, 2);
    var decimalString = Array(decimals).fill('0').join(''); // Note: does not support locales
    // TODO: change currency based on user locale or settings from this library

    return ssf.format("$#,##0.".concat(decimalString, "_);($#,##0.").concat(decimalString, ")"), number).trim();
  },
  EXACT: function EXACT(text1, text2) {
    text1 = H.accept(text1, [Types.STRING]);
    text2 = H.accept(text2, [Types.STRING]);
    return text1 === text2;
  },
  FIND: function FIND(findText, withinText, startNum) {
    findText = H.accept(findText, Types.STRING);
    withinText = H.accept(withinText, Types.STRING);
    startNum = H.accept(startNum, Types.NUMBER, 1);
    if (startNum < 1 || startNum > withinText.length) throw FormulaError.VALUE;
    var res = withinText.indexOf(findText, startNum - 1);
    if (res === -1) throw FormulaError.VALUE;
    return res + 1;
  },
  FINDB: function FINDB() {
    return TextFunctions.FIND.apply(TextFunctions, arguments);
  },
  FIXED: function FIXED(number, decimals, noCommas) {
    number = H.accept(number, Types.NUMBER);
    decimals = H.accept(decimals, Types.NUMBER, 2);
    noCommas = H.accept(noCommas, Types.BOOLEAN, false);
    var decimalString = Array(decimals).fill('0').join('');
    var comma = noCommas ? '' : '#,';
    return ssf.format("".concat(comma, "##0.").concat(decimalString, "_);(").concat(comma, "##0.").concat(decimalString, ")"), number).trim();
  },
  LEFT: function LEFT(text, numChars) {
    text = H.accept(text, Types.STRING);
    numChars = H.accept(numChars, Types.NUMBER, 1);
    if (numChars < 0) throw FormulaError.VALUE;
    if (numChars > text.length) return text;
    return text.slice(0, numChars);
  },
  LEFTB: function LEFTB() {
    return TextFunctions.LEFT.apply(TextFunctions, arguments);
  },
  LEN: function LEN(text) {
    text = H.accept(text, Types.STRING);
    return text.length;
  },
  LENB: function LENB() {
    return TextFunctions.LEN.apply(TextFunctions, arguments);
  },
  LOWER: function LOWER(text) {
    text = H.accept(text, Types.STRING);
    return text.toLowerCase();
  },
  MID: function MID(text, startNum, numChars) {
    text = H.accept(text, Types.STRING);
    startNum = H.accept(startNum, Types.NUMBER);
    numChars = H.accept(numChars, Types.NUMBER);
    if (startNum > text.length) return '';
    if (startNum < 1 || numChars < 1) throw FormulaError.VALUE;
    return text.slice(startNum - 1, startNum + numChars - 1);
  },
  MIDB: function MIDB() {
    return TextFunctions.MID.apply(TextFunctions, arguments);
  },
  NUMBERVALUE: function NUMBERVALUE(text, decimalSeparator, groupSeparator) {
    text = H.accept(text, Types.STRING); // TODO: support reading system locale and set separators

    decimalSeparator = H.accept(decimalSeparator, Types.STRING, '.');
    groupSeparator = H.accept(groupSeparator, Types.STRING, ',');
    if (text.length === 0) return 0;
    if (decimalSeparator.length === 0 || groupSeparator.length === 0) throw FormulaError.VALUE;
    decimalSeparator = decimalSeparator[0];
    groupSeparator = groupSeparator[0];
    if (decimalSeparator === groupSeparator || text.indexOf(decimalSeparator) < text.lastIndexOf(groupSeparator)) throw FormulaError.VALUE;
    var res = text.replace(groupSeparator, '').replace(decimalSeparator, '.') // remove chars that not related to number
    .replace(/[^\-0-9.%()]/g, '').match(/([(-]*)([0-9]*[.]*[0-9]+)([)]?)([%]*)/);
    if (!res) throw FormulaError.VALUE; // ["-123456.78%%", "(-", "123456.78", ")", "%%"]

    var leftParenOrMinus = res[1].length,
        rightParen = res[3].length,
        percent = res[4].length;
    var number = Number(res[2]);
    if (leftParenOrMinus > 1 || leftParenOrMinus && !rightParen || !leftParenOrMinus && rightParen || isNaN(number)) throw FormulaError.VALUE;
    number = number / Math.pow(100, percent);
    return leftParenOrMinus ? -number : number;
  },
  PHONETIC: function PHONETIC() {
    throw FormulaError.NOT_IMPLEMENTED('PHONETIC');
  },
  PROPER: function PROPER(text) {
    text = H.accept(text, [Types.STRING]);
    text = text.toLowerCase();
    text = text.charAt(0).toUpperCase() + text.slice(1);
    return text.replace(/(?:[^a-zA-Z])([a-zA-Z])/g, function (letter) {
      return letter.toUpperCase();
    });
  },
  REPLACE: function REPLACE(old_text, start_num, num_chars, new_text) {
    old_text = H.accept(old_text, [Types.STRING]);
    start_num = H.accept(start_num, [Types.NUMBER]);
    num_chars = H.accept(num_chars, [Types.NUMBER]);
    new_text = H.accept(new_text, [Types.STRING]);
    var arr = old_text.split("");
    arr.splice(start_num - 1, num_chars, new_text);
    return arr.join("");
  },
  REPLACEB: function REPLACEB() {
    return TextFunctions.REPLACE.apply(TextFunctions, arguments);
  },
  REPT: function REPT(text, number_times) {
    text = H.accept(text, Types.STRING);
    number_times = H.accept(number_times, Types.NUMBER);
    var str = "";

    for (var i = 0; i < number_times; i++) {
      str += text;
    }

    return str;
  },
  RIGHT: function RIGHT(text, numChars) {
    text = H.accept(text, Types.STRING);
    numChars = H.accept(numChars, Types.NUMBER, 1);
    if (numChars < 0) throw FormulaError.VALUE;
    var len = text.length;
    if (numChars > len) return text;
    return text.slice(len - numChars);
  },
  RIGHTB: function RIGHTB() {
    return TextFunctions.RIGHT.apply(TextFunctions, arguments);
  },
  SEARCH: function SEARCH(findText, withinText, startNum) {
    findText = H.accept(findText, Types.STRING);
    withinText = H.accept(withinText, Types.STRING);
    startNum = H.accept(startNum, Types.NUMBER, 1);
    if (startNum < 1 || startNum > withinText.length) throw FormulaError.VALUE; // transform to js regex expression

    var findTextRegex = WildCard.isWildCard(findText) ? WildCard.toRegex(findText, 'i') : findText;
    var res = withinText.slice(startNum - 1).search(findTextRegex);
    if (res === -1) throw FormulaError.VALUE;
    return res + startNum;
  },
  SEARCHB: function SEARCHB() {
    return TextFunctions.SEARCH.apply(TextFunctions, arguments);
  },
  SUBSTITUTE: function SUBSTITUTE() {},
  T: function T(value) {
    // extract the real parameter
    value = H.accept(value);
    if (typeof value === "string") return value;
    return '';
  },
  TEXT: function TEXT(value, formatText) {
    value = H.accept(value, Types.NUMBER);
    formatText = H.accept(formatText, Types.STRING); // I know ssf contains bugs...

    try {
      return ssf.format(formatText, value);
    } catch (e) {
      console.error(e);
      throw FormulaError.VALUE;
    }
  },
  TEXTJOIN: function TEXTJOIN() {},
  TRIM: function TRIM(text) {
    text = H.accept(text, [Types.STRING]);
    return text.replace(/^\s+|\s+$/g, '');
  }
}, _defineProperty(_TextFunctions, "TEXTJOIN", function TEXTJOIN() {}), _defineProperty(_TextFunctions, "UNICHAR", function UNICHAR(number) {
  number = H.accept(number, [Types.NUMBER]);
  if (number <= 0) throw FormulaError.VALUE;
  return String.fromCharCode(number);
}), _defineProperty(_TextFunctions, "UNICODE", function UNICODE(text) {
  return TextFunctions.CODE(text);
}), _TextFunctions);
module.exports = TextFunctions;